<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { hasErrors } from '@utils/form'
import { permissionsService } from '@utils/permissions'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { httpServices } from '@utils/http-services'

export default {
  page: {
    title: 'SIM Profile',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      sim: null,
      users: [],
      groups: [],
      phone: null,
      phoneFormatted: null,
      groupId: null,
      orgs: [],
      permissionsService: permissionsService,
      simbank: null,
      formLayout: 'horizontal',
      hardwareIds: [],
      hardwareLocations: [],
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getHardwares().then((res) => {
      this.hardwareIds = res.map((i) => i.meta.id)
      this.hardwareLocations = [...new Set(res.map((i) => i.meta.location))]
    })

    httpServices.getSimBank().then((res) => {
      this.simbank = res
    })

    axios
      .get(
        process.env.VUE_APP_KONSUL_API_URL +
          '/sims/' +
          this.$route.params.simId,
        {
          headers: {
            Authorization: 'Bearer ' + this.$auth.user.access_token,
          },
        }
      )
      .then((res) => {
        this.sim = res.data
        this.groupId = this.sim?.meta?.groupId.map((i) =>
          i.replace('GROUP#', '')
        )
        this.$nextTick(() => {
          this.form.validateFields()
        })
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/users/getAll', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.users = res.data.Items.map((user, i) => {
          return {
            ...user,
            key: i,
            email: user.pk.replace('USER#', ''),
          }
        })
      })
    httpServices.getGroups().then((groups) => {
      this.groups = groups
    })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/orgs', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.orgs = res.data.Items
      })
  },
  methods: {
    countryChanged(e) {
      if (e?.formattedNumber?.length) {
        this.phoneFormatted = e.formattedNumber.replace(/\+/g, '')
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.sim.meta = {
            ...this.sim.meta,
            userId: values.userId,
            groupId: values.groupId,
            orgId: values.orgId,
            hardwareId: values.hardwareId.toLowerCase(),
            simSlot: values.simSlot,
            imsi: values.imsi,
            location: values.location,
          }

          const x = this.simbank.filter((i) => i.imsi === this.sim.meta.imsi)

          if (!x?.length) {
            return this.$notification.error({
              message: 'Failed to recognize SIM on Sim Bank',
            })
          }
          if (x[0].slot.toString() !== this.sim.meta.simSlot.toString()) {
            return this.$notification.error({
              message:
                'This sim is currently in slot ' +
                x[0].slot.toString() +
                ', please fix before saving.',
            })
          }

          axios
            .put(process.env.VUE_APP_KONSUL_API_URL + '/sims', this.sim, {
              headers: {
                Authorization: 'Bearer ' + this.$auth.user.access_token,
              },
            })
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.phone || 'SIM'
                  } Successfully Updated`,
                })
                this.$router.push({
                  name: 'sim-management',
                })
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Update SIM',
                })
              }
            )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/sim-management">
              <a-icon type="phone" />
              <span>SIM Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="profile" />
            SIM Profile
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="profile" style="padding-right: 4px" />
            SIM Profile &middot; {{ this.$route.params.simId }}
          </h4>
        </div>

        <template v-if="sim">
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="SIM Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="6">
                        <a-form-item label="Select a Hardware Id">
                          <a-select
                            v-decorator="[
                              'hardwareId',
                              {
                                required: true,
                                initialValue: sim.meta.hardwareId,
                              },
                            ]"
                            :disabled="!permissionsService.isVanishedAdmin()"
                          >
                            <a-select-option
                              v-for="(h, i) in hardwareIds"
                              :key="h + i"
                              :value="h"
                            >
                              {{ h.toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="MTN">
                          <a-input
                            v-decorator="[
                              'mtn',
                              {
                                initialValue: sim.meta.mtn,
                              },
                            ]"
                            :disabled="true"
                          />
                        </a-form-item>
                        <a-form-item label="SIM MTN">
                          <a-input
                            v-decorator="[
                              'mtn',
                              {
                                initialValue: sim.meta.mtn,
                              },
                            ]"
                            :disabled="!permissionsService.isVanishedAdmin()"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="IMSI">
                          <a-input
                            v-decorator="[
                              'imsi',
                              {
                                initialValue: sim.meta.imsi,
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="SIM Slot Position">
                          <a-input-number
                            v-decorator="[
                              'simSlot',
                              {
                                initialValue: parseInt(sim.meta.simSlot),
                                rules: [
                                  {
                                    required: true,
                                    type: 'any',
                                  },
                                ],
                              },
                            ]"
                            :min="1"
                            :max="450"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Select a location">
                          <a-select
                            v-decorator="[
                              'location',
                              {
                                initialValue: sim.meta.location,
                                rules: [
                                  {
                                    required: true,
                                    type: 'any',
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(l, i) in hardwareLocations"
                              :key="i"
                              :value="l"
                            >
                              {{ l }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Select an Organization">
                          <a-select
                            v-decorator="[
                              'orgId',
                              {
                                required: true,
                                initialValue: sim.meta.orgId,
                              },
                            ]"
                            :disabled="!permissionsService.isVanishedAdmin()"
                          >
                            <a-select-option
                              v-for="(org, i) in orgs"
                              :key="i"
                              :value="org.pk.replace('ORG#', '')"
                            >
                              {{ org.pk.replace('ORG#', '').toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="groupId">
                          <a-select
                            v-decorator="[
                              'groupId',
                              {
                                initialValue: groupId,
                              },
                            ]"
                            mode="multiple"
                          >
                            <a-select-option
                              v-for="group in groups"
                              :key="group.pk"
                              :value="group.pk"
                            >
                              {{ group.pk.replace('GROUP#', '') }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="userId">
                          <a-select
                            v-decorator="[
                              'userId',
                              {
                                initialValue: sim.meta.userId,
                              },
                            ]"
                            mode="multiple"
                          >
                            <a-select-option
                              v-for="user in users"
                              :key="user.key"
                              :value="user.email"
                            >
                              {{ user.email }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
        <template v-else>
          <div class="loader--container">
            <a-icon
              type="loading"
              style="padding-left: 4px; font-size: 24px; color: #1890ff"
              spin
            />
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>
